import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import { Link } from 'react-router-dom'
import naturalCompare from 'natural-compare'
import _ from 'lodash'

import {
  Table,
  Breadcrumbs,
  Grid,
  Notifications,
  Loading,
} from 'components/UI'
import UnitFilters from './UnitFilters'

class UnitList extends Component {
  state = {
    floorFilter: [],
    lineFilter: [],
  }

  handleFilterChange = ({ floors, lines }) => {
    this.setState({
      floorFilter: floors,
      lineFilter: lines,
    })
  }

  render () {
    const {
      match,
      data,
    } = this.props

    const {
      floorFilter,
      lineFilter,
    } = this.state

    const {
      error,
      loading,
      building,
    } = data

    if (error) return <Notifications.Error message={error.message} />

    const units = loading ? [] : building.units

    const filteredByFloor = _.filter(units, unit => (
      floorFilter.length === 0 || _.includes(floorFilter, unit.floor.id)
    ))
    
    const filteredByLine = _.filter(units, unit => (
      lineFilter.length === 0 || (unit.line && _.includes(lineFilter, unit.line.id))
    ))

    const filteredUnits = _.intersection(filteredByFloor, filteredByLine)

    const buildingId = match.params.buildingId
    const buildingPath = `/buildings/${buildingId}`

    const breadcrumbs = [
      { name: loading ? '...' : building.name, to: buildingPath },
      { name: 'Units', to: `${buildingPath}/units` },
    ]

    const columns = [{
      Header: 'Unit',
      id: 'name',
      accessor: item => ({ id: item.id, name: item.name }),
      Cell: ({ value }) => (
        <Link to={`/units/${value.id}`}>
          {value.name}
        </Link>
      ),
      sortMethod: (a, b) => naturalCompare(a.name, b.name),
    }, {
      Header: 'Radiator Type',
      accessor: 'radiatorType',
    }, {
      Header: 'Floor',
      accessor: 'floor.name',
    }, {
      Header: 'Line',
      accessor: 'line.name',
    }, {
      Header: '% Radiators Reporting',
      id: 'ratio',
      accessor: item => item.ratio || 0,
      Cell: ({ value }) => `${value}%`,
    }]

    return (
      <Grid>
        <Grid.Row>
          <Breadcrumbs items={breadcrumbs} />
        </Grid.Row>
        <UnitFilters
          buildingId={buildingId}
          onChange={this.handleFilterChange}
        />
        <Grid.Row>
          { loading ? <Loading /> :
            <Table
              data={filteredUnits}
              columns={columns}
            />
          }
        </Grid.Row>
      </Grid>
    )
  }
}

const UnitListQuery = gql`
  query UnitListQuery($id: Int!) {
    building(id: $id) {
      name
      units {
        id
        name
        floor {
          id
          name
        }
        line {
          id
          name
        }
        ratio
      }
    }
  }
`

export default graphql(UnitListQuery, {
  options: ({ match }) => ({
    variables: {
      id: match.params.buildingId
    },
    notifyOnNetworkStatusChange: true,
  }),
})(UnitList)



// WEBPACK FOOTER //
// ./src/components/Unit/UnitList.jsx